import { forwardRef } from "react";
import type { LucideIcon, LucideProps } from "lucide-react";
import { CompanionFallback } from "./companionFallback";
import { useAssistantConfig } from "./useAssistantConfig";

/**
 * The sidebar's Mochi entry: the person's own companion, in the colour they
 * picked for it, standing in for a generic icon. Shaped like a lucide icon
 * (`size`, `className`) so navigation can render it wherever a route icon goes.
 */
const MochiNavIconImpl = forwardRef<HTMLSpanElement, LucideProps>(function MochiNavIcon(
  { size = 16, className },
  ref,
) {
  const { avatar_hue } = useAssistantConfig();
  // The creature fills less of its box than a stroke icon, so it gets a
  // little more room to read at the same visual weight.
  const px = Math.round(Number(size) * 1.4);
  return (
    <span
      ref={ref}
      aria-hidden
      data-testid="mochi-nav-icon"
      className={`inline-block shrink-0 ${className ?? ""}`}
      style={{ width: px, height: px }}
    >
      <CompanionFallback hue={avatar_hue} />
    </span>
  );
});

export const MochiNavIcon = MochiNavIconImpl as unknown as LucideIcon;
